import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SideBar from "../layout/sidebar/sidebar.jsx";
import UserHeader from "../layout/header.jsx";
import options from "../layout/sidebar/dashboard-options";
import * as PatientActions from "../../redux/actions/patient-actions";
import * as StudyActions from "../../redux/actions/study-actions";
import * as EasiScoreActions from "../../redux/actions/easi-scores-actions";
import "react-h5-audio-player/lib/styles.css";
import {
  Layout,
  Row,
  Col,
  Avatar,
  Typography,
  List,
  Spin,
  Card,
  Button,
  Form,
  Input,
  PageHeader,
} from "antd";
import moment from "moment-timezone";
import { notifyUser } from "../../services/notification-service";
import firebase from "../../../config/firebase";
import Config from "../../config";
import { ChatSvg } from "../shared/svg/chatlg";
import { ServeySvg } from "../shared/svg/servey";
import { DataSvg } from "../shared/svg/dataicon";
import { DairySvg } from "../shared/svg/dairyicon";
import { AdverseEventSvg } from "../shared/svg/adverseevents";
import { PhotogallerySvg } from "../shared/svg/photogallery";
import { MedicationIconSvg } from "../shared/svg/medication";
import Icon from "@ant-design/icons";
import { LabSvg } from "../shared/svg/labicon";
import { AuditOutlined } from "@ant-design/icons";

const LabIcon = (props) => <Icon component={LabSvg} {...props} />;
const dateFormathh = "MM/DD/YYYY";
const { Header, Sider, Content } = Layout;
const ChatIcon = (props) => <Icon component={ChatSvg} {...props} />;
const ServeyIcon = (props) => <Icon component={ServeySvg} {...props} />;
const DataIcon = (props) => <Icon component={DataSvg} {...props} />;
const DairyIcon = (props) => <Icon component={DairySvg} {...props} />;
const AdverseEventIcon = (props) => (
  <Icon component={AdverseEventSvg} {...props} />
);
const PhotogalleryIcon = (props) => (
  <Icon component={PhotogallerySvg} {...props} />
);
const MedicationIcon = (props) => (
  <Icon component={MedicationIconSvg} {...props} />
);
const ButtonGroup = Button.Group;

class EASITotal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      patientData: undefined,
      loading: true,
      submitted: false,
      selectedBodyPart: "reviewTotal",
      patientVoiceDiary: [],
      selectItemId: "",
      selectedCol: "",
      adverseEvent: undefined,
      easiTotal: undefined,
      month: 1,
      monthNih: 1,
      week: 1,
      selectedMonth: 1,
      selectedWeek: 1,
      selectedMonthNih: 1
    };
  }

  async componentDidMount() {
    let studyId = localStorage.getItem("studyId");
    this.props
      .getStudyById(studyId)
      .then((resp) => {
        this.setState({
          // loading: false,
          data: resp.data,
        });
      })
      .catch((ex) => {
        this.setState({ loading: false });
      });
    let patientId = this.props.match.params.id;
    let month = this.state.month;
    let monthNih = this.state.monthNih;
    let week = this.state.week;
    // await this.props.getPatientById(patientId);
    if (studyId == 2) {
      await this.props.getPatientByIdJanssen(patientId);
    } else if (studyId == 4){
      await this.props.getPatientByIdNih(patientId);
    } else {
      await this.props.getPatientById(patientId);
    }
    if (
      this.props.patientData &&
      this.props.patientData.length > 0 &&
      this.props.patientData[0]
    ) {
      // this.setState({ loading: false })
    } else if (this.props.patientDataError) {
      notifyUser(this.props.patientDataError, "error");
      this.props.history.push("/patients/1");
    }
    if (studyId == "1") {
      await this.props.getEasiTotal(month, patientId);
    } else if (studyId === "4") {
      if (this.props.weekByParts && this.props.weekByParts.patId &&
        this.props.weekByParts.patId === patientId
      ) {
        await this.getPhotosNih(this.props.weekByParts.curMonth);
      } else {
        await this.props.getEasiScoreForNih(monthNih, patientId);
      }
    } else {
      if (this.props.weekByParts && this.props.weekByParts != undefined) {
        await this.getPhotosWeek(this.props.weekByParts);
      } else {
        await this.props.getEasiScoreForJanssen(week, patientId);
      }
    }    
    if (this.props.easiTotal) {
      this.setState({ easiTotal: this.props.easiTotal, loading: false });
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.easiTotal !== nextProps.easiTotal) {
      this.setState({ easiTotal: nextProps.easiTotal });
      this.setState({ loading: false });
    }
  }

  toggleSidebar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  goToChat = () => {
    var patientId = this.props.match.params.id;
    var ref = firebase.firestore().collection("chatrooms");
    var type = Config.server.type;
    ref
      .where(`users.${patientId + type}`, "==", true)
      .get()
      .then((docs) => {
        let room = {};
        docs.forEach((snapshot) => {
          room = snapshot.data();
          room.id = snapshot.id;
        });
        this.props.history.push("/chat/" + patientId);
      });
  };

  goToDiary = (colId) => {
    this.setState({ selectedCol: colId });
    var patientId = this.props.match.params.id;
    this.props.history.push("/patient-diary/" + patientId);
  };

  goToPhotoGallery = (id) => {
    this.setState({ selectedCol: id });
    var patientId = this.props.match.params.id;
    this.props.history.push("/photo-gallery/" + patientId);
  };
  goToPatientProgress = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/patient-progress/" + patientId);
  };

  goToFlares = (id) => {
    this.setState({ selectedCol: id });
    var patientId = this.props.match.params.id;
    this.props.history.push("/flares/" + patientId);
  }

  goToActivityData = (id) => {
    this.setState({ selectedCol: id });
    var patientId = this.props.match.params.id;
    this.props.history.push("/activity-data/" + patientId);
  };

  goToEASiScoring = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/EASI-head/" + patientId);
  };

  goToAdverseEvents = (id) => {
    this.setState({ selectedCol: id });
    var patientId = this.props.match.params.id;
    this.props.history.push("/adverse-events/" + patientId);
  };

  goToLowerExt = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/EASI-lowerExt/" + patientId);
  };
  goToUpperExt = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/EASI-upperExt/" + patientId);
  };
  goToTrunk = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/EASI-trunk/" + patientId);
  };

  goToReviewTotal = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/EASI-total/" + patientId);
  };

  goToGlobalAssessment = () => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/globalAssessment/" + patientId);
  };

  goToLab = (id) => {
    var patientId = this.props.match.params.id;
    this.props.history.push("/lab/" + patientId);
  };

  async getPhotos(month) {
    var patientId = this.props.match.params.id;
    this.setState({ selectedMonth: month, month: month, loading: true });

    await this.props.getEasiTotal(month, patientId);
    if (this.props.easiTotal) {
      this.setState({ easiTotal: this.props.easiTotal, loading: false });
    }
  }

  async getPhotosWeek(week) {
    var patientId = this.props.match.params.id;
    this.setState({ selectedWeek: week, month: week, loading: true });

    await this.props.getEasiScoreForJanssen(week, patientId);
    if (this.props.easiTotal) {
      this.setState({ easiTotal: this.props.easiTotal, loading: false });
      await this.props.getLocalState(week);
    }
  }

  async getPhotosNih(monthNih) {
    var patientId = this.props.match.params.id;
    this.setState({ selectedMonthNih: monthNih, monthNih: monthNih, loading: true });

    await this.props.getEasiScoreForNih(monthNih, patientId);
    if (this.props.easiTotal) {
      this.setState({ easiTotal: this.props.easiTotal, loading: false });
      let data = {
        patId: patientId,
        curMonth: monthNih
      }
      await this.props.getLocalState(data);
    }
  }

  goToNewMed = (id) => {
    this.setState({ selectedCol: id });
    var patientId = this.props.match.params.id;
    this.props.history.push("/new-medication/" + patientId);
  }

  render() {
    const { selectedBodyPart, selectedMonthNih, selectedCol, loading, easiTotal, selectedMonth, selectedWeek } =
      this.state;

      const patientData = this.props.patientData;


    const oldDate = this.props.patientData && this.props.patientData[0] && this.props.patientData[0].dateOfBirth
    const dateType = !isNaN(Date.parse(oldDate))
    let finalDate = "";
    if (oldDate && dateType == true) {
      finalDate = moment(oldDate).format("MM/DD/YYYY")
    } else if (oldDate && dateType == false) {
      finalDate = moment(new Date(Number(oldDate))).format("MM/DD/YYYY")
    } else {
      finalDate = "N/A"
    }

    const patientDataHealth = this.props.patientData && this.props.patientData[0];


    const studyId = localStorage.getItem("studyId");

    // Patient Start End time
    const notificationEndDate = this.props.patientData && this.props.patientData[0] && this.props.patientData[0].notificationEndDate;
    const notificationTimezone = this.props.patientData && this.props.patientData[0] && this.props.patientData[0].notificationTimezone;
    const endDateInTimezone = moment.tz(notificationEndDate, notificationTimezone);
    let formattedTimeEnd = "";
    if (this.props.patientData && this.props.patientData[0] && this.props.patientData[0].notificationEndDate) {
      formattedTimeEnd = endDateInTimezone.format('hh:mm A');
    } else {
      formattedTimeEnd = "";
    }
    const formattedTimeEndData = formattedTimeEnd;

    const notificationStartDate = this.props.patientData && this.props.patientData[0] && this.props.patientData[0].notificationStartDate;
    const startDateInTimezone = moment.tz(notificationStartDate, notificationTimezone);
    let formattedTimeStart = "";
    if (this.props.patientData && this.props.patientData[0] && this.props.patientData[0].notificationStartDate) {
      formattedTimeStart = startDateInTimezone.format('hh:mm A');
    } else {
      formattedTimeStart = "";
    }
    const formattedTimeStartData = formattedTimeStart;
    // Patient Start End time end

    return (
      <Layout>
        <Sider
          breakpoint="xl"
          collapsedWidth="0"
          width="260px"
          className="sidebar"
          // trigger={null}
          onBreakpoint={(broken) => {
            console.log(broken);
          }}
          // collapsible
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
        // collapsed={this.state.collapsed}
        >
          <SideBar {...this.props} options={options.dashBoardOptions} />
        </Sider>
        <Layout className="site-layout">
          <Header
            className="site-layout-background"
            style={{
              background: "#f2f5f9",
              zIndex: 100,
              top: 0,
              width: "100%",
              padding: 0,
            }}
          >
            <UserHeader
              {...this.props}
              isCollapsed={this.state.collapsed}
              toggleSidebar={this.toggleSidebar}
            />
          </Header>
          <Content className="site-layout-background">
            <PageHeader
              className="site-header-title"
              title={
                this.state.data &&
                  this.state.data.title
              }
            ></PageHeader>
            <Spin spinning={loading}>
              {!this.state.loading && (
                <Row gutter={16}>
                  <Col xs={24} sm={12} md={6} xl={6}>
                    <div className="white-box user-section">
                      <div className="user-profile">
                        <Link to={"/patient-progress/" + this.props.match.params.id} >
                          <Avatar size={84}>
                            {this.props.patientData &&
                              this.props.patientData[0].firstName
                                .toUpperCase()
                                .charAt(0) +
                              this.props.patientData[0].lastName
                                .toUpperCase()
                                .charAt(0)}
                          </Avatar>
                        </Link>
                        <div className="profile-details">
                          <Link to={"/patient-progress/" + this.props.match.params.id} >
                            <h3>
                              {this.props.patientData &&
                                this.props.patientData[0].firstName +
                                " " +
                                this.props.patientData[0].lastName}
                            </h3>
                          </Link>
                          {
                            studyId == 1 ?
                            <button
                              className="btn"
                              onClick={() => this.goToChat()}
                            >
                              Chat Now
                            </button>
                            :
                            ""
                          }
                        </div>
                      </div>
                      <div className="user-details">
                        <List
                          style={{ marginTop: "40px" }}
                          itemLayout="horizontal"
                          dataSource={this.props.patientData}
                          renderItem={(patient) => (
                            <>
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Study:
                                </Typography.Text>{" "}
                                {patient && patient.title}
                              </List.Item>
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Email:
                                </Typography.Text>{" "}
                                {patient.email}
                              </List.Item>
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Date of Birth:
                                </Typography.Text>{" "}
                                {/* {patient.dateOfBirth
                                  ? moment(new Date(Number(patient.dateOfBirth))).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "N/A"} */}
                                  {finalDate}
                              </List.Item>
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Age:
                                </Typography.Text>{" "}
                                {patient.age ? patient.age + " years" : "N/A"}
                              </List.Item>
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Phone Number:
                                </Typography.Text>{" "}
                                {"(" +
                                  patient.phoneCode +
                                  ") " +
                                  patient.phoneNumber}
                              </List.Item>
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Member Status:
                                </Typography.Text>{" "}
                                {patient.userScreeningStatus.replace("_", " ")}
                              </List.Item>
                              {
                                studyId == 2 ?
                                <List.Item>
                                  <Typography.Text style={{ color: "#006297" }}>
                                    Patient's TimeZone:
                                  </Typography.Text>{" "}
                                    {patient.notificationTimezone}
                                </List.Item>
                                : ""
                              }
                              {
                                studyId == 2 ?
                                <List.Item>
                                  <Typography.Text style={{ color: "#006297" }}>
                                    Notifications Time:
                                  </Typography.Text>{" "}
                                    {formattedTimeStartData} {!formattedTimeStartData && !formattedTimeEndData ? "" : "to"} {formattedTimeEndData}
                                </List.Item>
                                : 
                                ""
                              }
                              <List.Item>
                                <Typography.Text style={{ color: "#006297" }}>
                                  Registered Date:
                                </Typography.Text>{" "}
                                {
                                  studyId === "4" && patient.nihCreatedDate
                                    ? moment(patient.nihCreatedDate).format(dateFormathh)
                                    : patient.createdDate
                                      ? moment(patient.createdDate).format(dateFormathh)
                                      : "N/A"
                                }
                              </List.Item>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={18} xl={18}>
                    {studyId == 1 ?
                      <ButtonGroup className="horizontal-button-tabs">
                        <Button
                          className={selectedMonth === 1 ? "active" : ""}
                          onClick={() => this.getPhotos(1)}
                        >
                          Month 1
                        </Button>
                        <Button
                          className={selectedMonth === 2 ? "active" : ""}
                          onClick={() => this.getPhotos(2)}
                        >
                          Month 2
                        </Button>
                        <Button
                          className={selectedMonth === 3 ? "active" : ""}
                          onClick={() => this.getPhotos(3)}
                        >
                          Month 3
                        </Button>
                        <Button
                          className={selectedMonth === 4 ? "active" : ""}
                          onClick={() => this.getPhotos(4)}
                        >
                          Month 4
                        </Button>
                        <Button
                          className={selectedMonth === 5 ? "active" : ""}
                          onCldefaultExcoriationick={() => this.getPhotos(5)}
                        >
                          Month 5
                        </Button>
                        <Button
                          className={selectedMonth === 6 ? "active" : ""}
                          onClick={() => this.getPhotos(6)}
                        >
                          Month 6
                        </Button>
                      </ButtonGroup> 
                      : studyId === "4" ?
                      <ButtonGroup className="horizontal-button-tabs spaces">
                        <Button
                          className={selectedMonthNih === 1 ? "active" : ""}
                          onClick={() => this.getPhotosNih(1)}
                        >
                          Month 0
                        </Button>
                        <Button
                          className={selectedMonthNih === 2 ? "active" : ""}
                          onClick={() => this.getPhotosNih(2)}
                        >
                          Month 1
                        </Button>
                        <Button
                          className={selectedMonthNih === 3 ? "active" : ""}
                          onClick={() => this.getPhotosNih(3)}
                        >
                          Month 2
                        </Button>
                        <Button
                          className={selectedMonthNih === 4 ? "active" : ""}
                          onClick={() => this.getPhotosNih(4)}
                        >
                          Month 3
                        </Button>
                        <Button
                          className={selectedMonthNih === 5 ? "active" : ""}
                          onClick={() => this.getPhotosNih(5)}
                        >
                          Month 4
                        </Button>
                        <Button
                          className={selectedMonthNih === 6 ? "active" : ""}
                          onClick={() => this.getPhotosNih(6)}
                        >
                          Month 5
                        </Button>
                        <Button
                          className={selectedMonthNih === 7 ? "active" : ""}
                          onClick={() => this.getPhotosNih(7)}
                        >
                          Month 6
                        </Button>
                      </ButtonGroup>
                      : 
                      <ButtonGroup className="horizontal-button-tabs spaces">
                        <Button
                          className={selectedWeek === 1 ? "active" : ""}
                          onClick={() => this.getPhotosWeek(1)}
                        >
                          Week 0
                        </Button>  
                        <Button
                          className={selectedWeek === 3 ? "active" : ""}
                          onClick={() => this.getPhotosWeek(3)}
                        >
                          Week 2
                        </Button>  
                        <Button
                          className={selectedWeek === 5 ? "active" : ""}
                          onClick={() => this.getPhotosWeek(5)}
                        >
                          Week 4
                        </Button>  
                        <Button
                          className={selectedWeek === 7 ? "active" : ""}
                          onClick={() => this.getPhotosWeek(7)}
                        >
                          Week 6
                        </Button>
                        <Button
                          className={selectedWeek === 9 ? "active" : ""}
                          onClick={() => this.getPhotosWeek(9)}
                        >
                          Week 8
                        </Button>   
                      </ButtonGroup>
                    }
                    <ButtonGroup className="horizontal-button-tabs spaces">
                      <Button onClick={() => this.goToEASiScoring()}>
                        Head
                      </Button>
                      <Button onClick={() => this.goToUpperExt()}>
                        {studyId == 4 ? "Upper Limbs" : "Upper Extremity"}
                      </Button>
                      <Button onClick={() => this.goToLowerExt()}>
                        {studyId == 4 ? "Lower Limbs" : "Lower Extremity"}
                      </Button>
                      <Button onClick={() => this.goToTrunk()}>Trunk</Button>
                      <Button
                        className={
                          selectedBodyPart === "reviewTotal" ? "active" : ""
                        }
                        onClick={() => this.goToReviewTotal()}
                      >
                        Review Total Scores
                      </Button>
                      <Button onClick={() => this.goToGlobalAssessment()}>
                        Global Assessment
                      </Button>
                    </ButtonGroup>
                    <Card
                      title={"Patient Data"}
                      extra={
                        <Button onClick={() => this.goToPatientProgress()}>
                          Back
                        </Button>
                      }
                      style={{ marginBottom: "8px", padding: "0 16px" }}
                      className="patient-dairy-section"
                    >
                      <Row gutter={0}>
                        <Col xs={24} sm={24} md={12} xl={12}>
                          {/* Activity Content Section Start */}
                          <div className="easi-content-section">
                            <div className="play-icon-container"></div>
                            <Spin spinning={loading}>
                              {easiTotal ? (
                                <Form
                                  // layout={formLayout}
                                  //onFinish={this.handleSubmit}
                                  className="add-user patient-data-form"
                                >
                                  <Form.Item
                                    name="head"
                                    label={
                                      studyId === "4" && patientData && patientData[0] && patientData[0].healthCondition === "PSORIASIS" ? 
                                      "PASI (head)" :
                                      "EASI (head)"
                                    }
                                    // label="EASI (head)"
                                    initialValue={
                                      // easiTotal.head ? easiTotal.head : ""
                                      easiTotal && easiTotal.head
                                    ? easiTotal.head :
                                    easiTotal.head == 0 ? 0
                                    : easiTotal && easiTotal.head_and_neck
                                      ? easiTotal.head_and_neck
                                      : easiTotal.head_and_neck == 0 ?
                                      0 :
                                      ""
                                    }
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                  <Form.Item
                                    name="upperExt"
                                    label= {
                                      studyId === "4" && patientData && patientData[0] && patientData[0].healthCondition === "PSORIASIS" ? 
                                      "PASI (upper limbs)" :
                                      studyId === "4" ? "EASI (upper limbs)" :
                                      "EASI (upper ext.)"
                                    }
                                    // label="EASI (upper ext.)"
                                    initialValue={
                                      // easiTotal.upper_extremity ? easiTotal.upper_extremity : ""
                                      easiTotal && easiTotal.upper_extremity
                                    ? easiTotal.upper_extremity
                                    : easiTotal && easiTotal.upper_body
                                      ? easiTotal.upper_body
                                      : easiTotal.upper_body == 0 ? 0 
                                    : easiTotal && easiTotal.upper_limbs ?
                                      easiTotal.upper_limbs 
                                      : easiTotal.upper_limbs == 0 ? 0 :
                                      ""
                                    }
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                  <Form.Item
                                    name="lowerExt"
                                    label= {
                                      studyId === "4" && patientData && patientData[0] && patientData[0].healthCondition === "PSORIASIS" ? 
                                      "PASI (lower limbs)" :
                                      studyId === "4" ? "EASI (lower limbs)" :
                                      "EASI (lower ext.)"
                                    }
                                    // label="EASI (lower ext.)"
                                    initialValue={
                                      // easiTotal.lower_extremity ? easiTotal.lower_extremity : ""
                                      easiTotal && easiTotal.lower_extremity
                                    ? easiTotal.lower_extremity
                                    : easiTotal && easiTotal.lower_body
                                      ? easiTotal.lower_body
                                      : easiTotal.lower_body == 0 ? 0 
                                    : easiTotal && easiTotal.lower_limbs ?
                                    easiTotal && easiTotal.lower_limbs 
                                      : easiTotal.lower_limbs === 0 ? 0 :
                                      ""
                                    }
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                  <Form.Item
                                    name="trunk"
                                    label= {
                                      studyId === "4" && patientData && patientData[0] && patientData[0].healthCondition === "PSORIASIS" ? 
                                      "PASI (trunk)" :
                                      "EASI (trunk)"
                                    }
                                    // label="EASI (trunk)"
                                    initialValue={
                                      // easiTotal.trunk ? easiTotal.trunk : ""
                                      easiTotal && easiTotal.trunk
                                    ? easiTotal.trunk :
                                    easiTotal.trunk == 0 ? 0
                                    : easiTotal && easiTotal.full_body
                                      ? easiTotal.full_body
                                      : easiTotal.full_body == 0 ?
                                      0 :
                                      ""
                                    }
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                  <Form.Item
                                    name="total"
                                    label={
                                      studyId === "4" && patientData && patientData[0] && patientData[0].healthCondition === "PSORIASIS" ? 
                                      "PASI (total)" :
                                      "EASI (total)"
                                    }
                                    // label="EASI (total)"
                                    initialValue={
                                      easiTotal.total ? easiTotal.total : 
                                      easiTotal.total == 0 ? "0" :
                                      ""
                                    }
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                  {/*<Col xs={24} sm={24} md={24} className="form-button-group">
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit">Submit</Button>
                                            </Form.Item>
                               </Col>*/}
                                </Form>
                              ) : (
                                ""
                              )}
                            </Spin>
                          </div>
                        </Col>
                      </Row>
                    </Card>

                    <ul className="link-list-box" style={{ display: "block" }}>
                      {
                        studyId == 1 ?
                        <li>
                          <div onClick={() => this.goToChat()} class="link-box">
                            <ChatIcon />
                            <h4>Chat</h4>
                          </div>
                        </li>
                        :
                        ""
                      }
                      <li>
                        <div
                          onClick={() => this.goToEASiScoring()}
                          class="link-box"
                        >
                          <ServeyIcon />
                          <h4>Surveys &amp; Scores</h4>
                        </div>
                      </li>
                      <li>
                        <div
                          onClick={() => this.goToDiary("diary")}
                          className={
                            selectedCol === "diary"
                              ? "link-box selected-item-list"
                              : "link-box"
                          }
                        >
                          <DairyIcon />
                          <h4>Diary</h4>
                        </div>
                      </li>
                      <li>
                        <div
                          onClick={() => this.goToPhotoGallery("gallery")}
                          className={
                            selectedCol === "gallery"
                              ? "link-box selected-item-list"
                              : "link-box"
                          }
                        >
                          <PhotogalleryIcon />
                          <h4>Photo Gallery </h4>
                        </div>
                      </li>
                      <li>
                        <div
                          className={
                            selectedCol === "adverseEvents"
                              ? "link-box selected-item-list"
                              : "link-box"
                          }
                          onClick={() => this.goToAdverseEvents("adverse")}
                        >
                          <AdverseEventIcon />
                          <h4>Adverse Events</h4>
                        </div>
                      </li>
                      <li>
                        <div
                          onClick={() => this.goToActivityData("activity")}
                          class="link-box"
                        >
                          <DataIcon />
                          <h4>Activity Data</h4>
                        </div>
                      </li>
                      {
                        studyId == 1 ?
                        <li>
                          <div
                            onClick={() => this.goToLab("lab")}
                            class="link-box"
                          >
                            <LabIcon />
                            <h4>Lab</h4>
                          </div>
                        </li>
                        : 
                        ""
                      }
                      {
                        studyId == 4 && (patientDataHealth && patientDataHealth.healthCondition !== "HEALTHY_CONTROL") ?
                        <li>
                          <div
                            onClick={() => this.goToFlares()}
                            class="link-box extra"
                          >
                            <AuditOutlined style={{fontSize: "35px"}}/>
                            <h4>Flares</h4>
                          </div>
                        </li>
                        : ""
                      }
                      {
                        studyId === "4" ?
                        <li>
                          <div
                            onClick={() => this.goToNewMed()}
                            class="link-box extra"
                          >
                            <MedicationIcon/>
                            <h4>Medication</h4>
                          </div>
                        </li>
                        : ""
                      }
                    </ul>
                  </Col>
                </Row>
              )}
            </Spin>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    easiTotal: state.easiScore.easiTotal,
    patientData: state.patient.patientData,
    weekByParts: state.patient.weekByParts
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...PatientActions, ...StudyActions, ...EasiScoreActions },
    dispatch
  );
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    EASITotal
  )
);
